import { ILogger } from '@cian/logger';
import { IHttpApi } from '@cian/http-api';
import { IFastFiltersUserSchema } from '../../repositories/monolith-python/entities/schemas/FastFiltersUserSchema';
import { fetchGetUserDataByRequest } from '../../repositories/monolith-python/v1/get-user-data-by-request';
import { IUsersResponse, IUsersResponseError } from '../../types/user/user';
import { mapUserResponse, mapUserResponseError } from '../../mappers/transformUserResponse';

interface IUserResolve {
  user: IFastFiltersUserSchema;
}

const DEFAULT_USER_STATE = {
  isAuthenticated: false,
};

export async function getUser(httpApi: IHttpApi, logger: ILogger, cookie?: string): Promise<IUserResolve> {
  try {
    const userDataByRequestDataResponse = await fetchGetUserDataByRequest<IUsersResponse, IUsersResponseError>({
      httpApi,
      parameters: {},
      config: {
        requestConfig: {
          headers: [['cookie', cookie || '']],
        },
      },
      mappers: {
        200: mapUserResponse,
        400: mapUserResponseError,
      },
    });

    if (userDataByRequestDataResponse && userDataByRequestDataResponse.statusCode === 200) {
      return {
        user: (userDataByRequestDataResponse as IUsersResponse).response.user,
      };
    }

    return {
      user: DEFAULT_USER_STATE as IFastFiltersUserSchema,
    };
  } catch (err) {
    logger.error(err, {
      message: err.message,
      stack: err.stack,
      comment: 'Ошибка запроса в get-user-data-by-request',
    });

    return {
      user: DEFAULT_USER_STATE as IFastFiltersUserSchema,
    };
  }
}
